import functions from "../util/functions";

const banco = functions.databaseConfig();

const reqReceitaseDespesas = {
	receitaseDespesas: function (api, dataIni, dataFim, tipoData) {
		return api
			.get(`v2/relatorios/receitasedespesas`, {
				params: {
					dataini: dataIni,
					datafim: dataFim,
					tipoData,
				},
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqReceitaseDespesas;
